<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> {{project.name}}</h3>
      <div class="box-tools">
        <el-button class="pull-right" size="mini" @click="goBack()" plain><i class="fa fa-reply"></i> 返回</el-button>
      </div>
    </div>
    <div class="box-body">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #32c5d2;">
            <div class="visual"><i class="fa fa-diamond text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">已结束</div>
                <span class="count">{{standardInfo.finish || 0}}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color:#3598dc" >
            <div class="visual"><i class="fa fa-credit-card text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">进行中</div>
                <span class="count">{{standardInfo.underway || 0}}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #e7505a">
            <div class="visual"><i class="fa fa-send text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">已删除</div>
                <span class="count">{{standardInfo.deleted || 0}}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #6fcb9d">
            <div class="visual"><i class="fa fa-send text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">已付款</div>
                <span class="count" v-if="project.free == 1 ">项目免费</span>
                <span class="count" v-else>{{ payNum }}人</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 工具栏-->
      <el-row>
        <el-col :span="12">
          <el-button plain size="small" @click="fencDownload"><i class="fa fa-download"></i> 批量下载</el-button>
<!--          <el-button plain size="small" @click="getCompanyReport"><i class="fa fa-database"></i> 下载企业报告</el-button>-->
          <el-button plain size="small" @click="doSearch"><i class="fa fa-refresh"></i> 刷新</el-button>
          <el-button plain size="small" @click="exportUserList"><i class="fa fa-file-excel-o"></i> 导出花名册</el-button>
          <el-dropdown placement="bottom-start" style="margin-left:10px;margin-right: 10px">
            <el-button plain size="small" @click="downLoadAnswerQR"><i class="fa fa-qrcode"></i> 下载答题二维码</el-button>
            <el-dropdown-menu slot="dropdown" class="personal_dropdown">
              <el-dropdown-item>
                <img :src="'/api/fenc/qrcode/' + projectId" alt="">
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button plain size="small" @click="toFenc()" v-if="isModel"><i class="fa fa-file-excel-o"></i> 胜任力模型</el-button>
        </el-col>
        <el-col :span="12" class="text-align-reverse">
          <el-form size="small" :model="searchFm" inline>
            <el-form-item prop="trueName" >
              <el-input v-model="searchFm.trueName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item prop="statue">
              <el-select v-model="searchFm.statue" clearable  placeholder="请选择">
                <el-option
                    v-for="item in statue_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-button size="small" type="primary"  @click="doSearch" plain><i class="fa fa-search"></i> 搜索</el-button>
          </el-form>
        </el-col>
      </el-row>

      <el-table class="list-table" :data="reportList" ref="standardTable" @selection-change="selectStandard" border :stripe="true" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column prop="demo" type="selection" align="center" width="50" :selectable="checkState"></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="trueName" label="姓名" width="120"></el-table-column>
        <el-table-column prop="age" label="年龄" width="80"></el-table-column>
        <el-table-column prop="unit" label="公司"></el-table-column>
        <el-table-column prop="department" label="部门" width="150"></el-table-column>
        <el-table-column label="付款状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payStatus==1" type="success" effect="plain" size="small">已付款</el-tag>
            <el-tag v-else type="warning" effect="plain" size="small">未付款</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.statue==1" type="" effect="plain" size="small">进行中</el-tag>
            <el-tag v-if="scope.row.statue==2" type="success" effect="plain" size="small">已结束</el-tag>
            <el-tag v-if="scope.row.statue==3" type="danger" effect="plain" size="small">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="开始时间" width="180" :formatter="formatDate"></el-table-column>
        <el-table-column prop="duration" label="时长" width="130" :formatter="formatDuration"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editRecord(scope.row)"><i class="fa fa-edit"></i> 修改</el-button>
            <el-button type="text" size="small" @click="goFenc(scope.row)" ><i class="fa fa-eye"></i> 查看</el-button>
            <el-button type="text" size="small" @click="deleteUser(scope.row, scope.$index)"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <page-bar v-model="page" @change="getStandardReport"></page-bar>
    </div>

  </div>
</template>

<script>
import qs from 'qs'
import {getStandardReport,deleteUser,getProjectUserNum} from "@/api/manage/company";
import {get,getModelType} from "@api/evaluation/project";
import {get as getScheme} from "@api/evaluation/scheme";
import { getPay } from "@api/evaluation/report";
import PageBar from "@components/PageBar";
import {deepClone,timeDuration} from "@/utils/index";
import { handleConfirm } from '@utils/confirm'
import { mapGetters } from 'vuex'
import dayjs from "dayjs";

export default {
  name: '',
  data() {
    return {
      addDrawer: false,
      drawerVisible: false,
      payNum: 0,
      project: {},
      page: {
        pageNo: 1,
        pageSize: 20,
        param: {}
      },
      reportList:[],
      searchFm:{},
      statue_list:[
        {label: '进行中', value: 1},
        {label: '已结束', value: 2},
        {label: '已删除', value: 3}
      ],
      now_edit:{},
      editDialog:false,
      downId:'', // 批量下载的数组ids
      standardInfo:'',
      isModel:false,
      scheme:{}
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters(['user', 'company']),
    projectId(){
      return this.$route.params.projectId
    }
  },
  components: {
    PageBar,
    // InfoEdit
  },
  methods: {
    getPay() {
      getPay(this.projectId).then(resp => {
        this.payNum = resp.data.result.pay;
      });
    },
    formatDate(cell) {
      if (cell.startTime) {
        return dayjs.unix(cell.startTime).format("YYYY-MM-DD HH:mm")
      }
    },
    init(){
      get(this.projectId).then(resp => {
        this.project = resp.data.result
      }).then(()=>{
        this.getStandardReport()
        this.getProjectUserNum ()
        this.getModelType()
        this.getScheme()
        this.getPay();
      })
    },
    getScheme(){
      getScheme(this.project.schemeId).then(res =>{
        this.scheme = res.data.result
        console.info(this.scheme)
      })
    },
    getStandardReport () {
      let {pageSize,pageNo} = this.page
      this.fetchData({pageSize,pageNo})
    },
    getModelType(){
      getModelType(this.projectId).then(res =>{
        this.isModel = res.data.result
      })
    },
    fetchData(query) {
      getStandardReport(this.projectId,query).then(res => {
        if (res.data.code === 200) {
          this.page = res.data.result || {}
          this.reportList = res.data.result.records || []
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    doSearch(){ // 获取当前页码的列表
      let data = { pageNo:1,pageSize:this.page.pageSize}
      let {trueName,statue} = this.searchFm
      let query = {...data,param:{trueName,statue}}
      this.fetchData(query)
    },
    formatDuration(row, column, val) {
      if(row.statue === 2){
        return timeDuration(row.startTime * 1000, row.endTime * 1000)
      }else{
        return '-'
      }
    },
    fencDownload () {
      if (!this.downId) {
        this.$message.warning('请选择人员')
      } else {
        let atag = document.createElement('a')
        atag.className = 'exportStandardReport'
        atag.href = `/api/fenc/report/zip/${this.project.schemeId}?${this.downId}`
        atag.setAttribute('target', '_blank')
        document.querySelector('body').appendChild(atag)
        atag.click()
        document.querySelector('.exportStandardReport').remove()
      }
    },
    downLoadAnswerQR () {
      let a = document.createElement('a')
      a.className = 'downLoadAnswer'
      a.href = '/api/project/qrcode/standard/' + this.projectId
      a.setAttribute('target', '_blank')
      a.setAttribute('download', this.project.projectName + '.jpg')
      document.querySelector('body').appendChild(a)
      a.click()
      document.querySelector('.downLoadAnswer').remove()
    },
    checkState (row, index) {
      if(row.statue === 2) {
        return true
      } else {
        return false
      }
    },
    exportUserList () {
      if (!this.page.total) {
        this.$message.error('还未有人员答题')
      } else {
        let a = document.createElement('a')
        a.className = 'exportUserReport'
        a.href = '/api/report/export/' + this.projectId
        a.setAttribute('target', '_blank')
        document.querySelector('body').appendChild(a)
        a.click()
        document.querySelector('.exportUserReport').remove()
      }
    },
    selectStandard () { // 批量下载标准方案
      let list = this.$refs.standardTable.selection
      let idList = []
      list.map(item => {
        idList.push(item.id)
      })
      this.downId = qs.stringify({ids:idList},{ arrayFormat: 'repeat' })
    },
    editRecord (data) {
      this.now_edit = deepClone(data)
      this.editDialog = true
    },
    saveRecord (flag = false) {
      this.editDialog = false
      if(flag){
        this.doSearch(1)
      }
    },
    deleteUser (item, index) {
      handleConfirm('确定删除该人员的报告吗, 是否继续?').then(() => {
        deleteUser(item.id).then(res => {
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.doSearch()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    getCompanyReport(){
      let atag = document.createElement('a')
      atag.className = 'exportCompanyReport'
      atag.href = `/api/company/excle/${this.projectId}`
      atag.setAttribute('target', '_blank')
      document.querySelector('body').appendChild(atag)
      atag.click()
      document.querySelector('.exportCompanyReport').remove()
    },
    goFenc(data){
      window.open(`/api/fenc/manage/pdf/${data.id}`,'target')
    },
    getProjectUserNum () {
      getProjectUserNum(this.projectId).then(res => {
        if (res.data.code === 200) {
          let info = res.data.result || {}
          this.standardInfo = info
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    toFenc(){
      this.$router.push({ path: `/evaluation/fenc/model/${this.projectId}`})
    },
    goBack(){
      this.$router.go(-1);
    }
  }
}
</script>

<style type="text/scss" lang="scss">
.dashboard-stat{
  border: none;
}
.dashboard-stat .visual {
  font-size: 58px;
  float: left;
  min-height: 50px;
}
.dashboard-stat .details {
  float: right;
  color: #ffffff;
}
</style>
